module.exports = __webpack_public_path__ + "img/钢坯全景会员.e3f5286f.png";